import JQueryView, { on } from '../../../../common/views/jqueryView';
import $ from 'jquery';

export default class ShowView extends JQueryView {
  constructor() {
    super('.simple_form');
  }

  @on({ event: 'change', selector: '#leave_confirmed' })
  onChangeLeaveConfirmed(event: JQuery.ChangeEvent) {
    const checked = $(event.currentTarget).prop('checked');
    $('#submit_button').prop('disabled', !checked);
  }
}
